import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';
import HelpArticleLink from '../../help-article-link';
import { linkIDs } from '../../../services/link-service/links';

import style from './missing.module.less';

const ConnectMissingNotification = ({ messages, className = '' }) => (
  <div className={classnames(style['connect-missing-card'], className)}>
    <div className={style.top}>
      <div className={style['icon-wrapper']}>
        <FontAwesomeIcon className={style.icon} icon={faInfoCircle} />
      </div>
      <div className={style.title}>{messages.title}</div>
    </div>
    <div className={style.bottom}>
      <div>{messages.message}</div>
      <Button className={style['setup-connect-button']} href='/settings/connect' theme='primary'>
        {messages.setup}
      </Button>
      <div>
        <HelpArticleLink articleId={linkIDs.ShipStationConnectHelp}>{messages.learnMore}</HelpArticleLink>
      </div>
    </div>
  </div>
);

ConnectMissingNotification.propTypes = {
  messages: PropTypes.shape({
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    setup: PropTypes.string.isRequired,
    learnMore: PropTypes.string.isRequired,
    forMac: PropTypes.string.isRequired,
    forWindows: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

export default ConnectMissingNotification;
